<div mat-dialog-title data-debug="extend-role-dialog">
  <su-headline h="h3" skin="primary">{{
    'administration.users.extend_dialog.title' | translate
  }}</su-headline>
</div>

<div mat-dialog-content>
  <form [formGroup]="form">
    <formly-form
      [form]="form"
      [fields]="formFields"
      [model]="formModel"></formly-form>
  </form>
</div>

<div mat-dialog-actions>
  <su-button
    skin="secondary"
    [label]="'shared.cancel' | translate"
    mat-dialog-close></su-button>

  <su-button
    skin="primary"
    [label]="'administration.users.extend_dialog.confirm' | translate"
    (onClick)="save()"></su-button>
</div>
